import React, { Component, Fragment } from 'react';
import {
  Card, CardBody, Col, Nav, NavItem, NavLink, TabContent, TabPane, Button
} from 'reactstrap';
import { change, reduxForm } from 'redux-form';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import BasicDataPatient from './BasicDataPatient/BasicDataPatient';
import DefaultTabsBorderedTopBackground from './Background/components/DefaultTabsBorderedTopBackground';
import SystemReview from "./SystemReview/SystemReview";
import PhysicalExam from './PhysicalExam/PhysicalExam';
import AnalysisAndMedicalPlan from './AnalysisAndMedicalPlan/AnalysisAndMedicalPlan';
import Diagnostic from './Diagnostic/Diagnostic';
import MedicalOrders from './MedicalOrders/MedicalOrders';
import MedicalProcedures from './MedicalProcedures/MedicalProcedures';
import SourceDocuments from './SourceDocuments/SourceDocuments';
import Ananmesis from './Ananmesis/Anamesis';
import Modal from '@material-ui/core/Modal';
import moment from 'moment';
import history from '../../../../history'
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import EventAdverse from './EventAdverse/EventAdverse';
import ProtocolDeviations from './ProtocolDeviations/ProtocolDeviations';
import Criteria from './Criteria/Criteria';
import ExamResult from './ExamResult/ExamResult';
import Consent from './Consent/Consent';

const sections = ['patologicos', 'quirurgicos', 'farmacologicos', 'urgencias', 'hospitalizaciones', 'planificacion', 'inmunización', 'familiares'];
const sectionMap = ['patologicos', 'quirurgicos', 'farmacologicos', 'urgencias', 'hospitalizaciones', 'planificacion', 'inmunizaciones', 'familiares']
const ailments = [
  //["Hipertensión", "Diabetes", "Hiperlipidemia", "Enf. Coronaria", "Enf. Vascular Periferica", "Hepatitis", "Cancer", "Transfusiones"],
  ["Hipertensión", "Metabólicos", "Cardiacos", "Infecciosos", "Vasculares", "Alérgicos", "Cancer", "Transfusiones", "Autoinmunes", "Traumático"],
  ["Quirurgico"],
  ["Farmacologico"],
  ["Urgencias"],
  ["Hospitalizaciones"],
  ["Tiene Vasectomia", "Planifica", "Tiene pareja sexual potencialmente fertil"],
  ["Inmunizaciones"],
  ["Enfermedad Coronaria", "diabetes", "cancer", "Muerte Subita (H<55/M<60)", "Hipertensión"],
  ["Alergías", "Hospitalario", "Traumatico", "Enfermedades de transmisión sexual", "Psiquiatricos"]
];

const ailmentsSystemReview = ["Síntomas Generales", "Respiratorios", "Cardiovascular", "Gastrointestinal", "Genitourinario", "Osteomuscular", "Dermatologico", "Endocrino", "Neurologico"];

class DefaultTabsBorderedTop extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      btnActive: true,
      activeTab: '1',
      loadTab: false,
      profile: sessionStorage.getItem('perfil'),
      idClinica: sessionStorage.getItem('id_clinica'),
      anamesis: {
        cause: "",
        reasonForConsultation: "",
        currentIllness: "",
        candidate: false,
        study: "",
        participate: false,
      },
      sectionAilment: {
        ailments: (() => {
          return sections.map((section, index) => {
            var sectionNew = { [section]: [] };
            ailments[index].map((ailment, i) => {
              sectionNew[section].push({ ailment: ailment, value: 'No', commentary: '' });
            })
            return sectionNew;
          })
        })(),
        commentary: (() => {
          return new Array(sections.length).fill(null);
        })(),
        planification: {
          method: "",
          ohter_method: "",
          observations: ""
        },
        habits: {
          packegesPerYear: "",
          cigarretsPerDay: "",
          yearStart: "",
          yearEnd: "",
          years: "",
          firewood: "",
          smoke: "",
          comsuption: "",
          substaces: [],
          substace: "",
          frecuency: "",
          alcohol: "",
          alcoholLastYear: "",
          frecuencyAlcohol: "",
          physicalActivity: "",
          frecuencyPhysicalActivity: "",
          activities: "",
          nutricional: ""
        }
      },
      SystemReview: {
        ailments: (() => {
          return ailmentsSystemReview.map((ailment) => {
            return { ailment: ailment, commentary: "" }
          })
        })(),
      },
      PhysicalExam: {
        gender: "",
        weight: "",
        abdominalPerimeter: "",
        size: "",
        heartRate: "",
        breathingFrequency: "",
        temperature: "",
        bloodPressure: "",
        BMI: "",
        bodySurface: "",
        dominance: "",
        generalFeatures: "",
        headAndFace: "",
        ori: "",
        eyes: "",
        neck: "",
        chest: "",
        cardioVascular: "",
        pulmonary: "",
        abdomen: "",
        limbs: "",
        neurological: "",
        genitourinary: "",
        skin_appendages: "",
        otorhino: "",
        load: false
      },
      Diagnostic: {
        cups: "",
        name: "",
        diagnostic: {},
        addedDiagnostics: [],
        dataOldDiagnostic: [],
        observations: [],
        dataDiagnostic: [],
        load: false
      },
      MedicalOrders: {
        cups: "",
        name: "",
        diagnostic: {},
        addedDiagnostics: [],
        observation: "",
        observations: [],
        dataDiagnostic: [],
        time: "",
        formulas: [],
        load: false,
      },
      AnalysisAndMedicalPlan: {
        analysis: "",
        plan: "",
        recommendations: ""
      },
      MedicalProcedures: {
        ECO: {
          vid: "",
          rao: "",
          e: "",
          pp: "",
          ao: "",
          a: "",
          ps: "",
          vd: "",
          tapse: "",
          vis: "",
          ai: "",
          ad: "",
          fe: "",
          adult: {},
          description: "",
          conclusions: "",
          professional: "",
          medicalOrders: [],
          medicament: {},
          addedMedicaments: [],
          observations: [],
          cie: {
            code: "",
            name: ""
          }
        },
        Stress: {
          vid: "",
          rao: "",
          e: "",
          pp: "",
          ao: "",
          a: "",
          ps: "",
          vd: "",
          tapse: "",
          vis: "",
          ai: "",
          ad: "",
          fe: "",
          adult: {},
          description: "",
          conclusions: "",
          professional: "",
          medicalOrders: [],
          medicament: {},
          addedMedicaments: [],
          observations: [],
          cie: {
            code: "",
            name: ""
          }
        },
        Test: {
          professional: "",
          conclusion: "",
          conclusions: "",
          medicament: {},
          addedMedicaments: [],
          cie: {
            code: "",
            name: ""
          }
        },
        Holter: {
          professional: "",
          conclusion: "",
          medicament: {},
          addedMedicaments: [],
          cie: {
            code: "",
            name: ""
          }
        },
        Map: {
          professional: "",
          conclusion: "",
          medicament: {},
          addedMedicaments: [],
          cie: {
            code: "",
            name: ""
          }
        },
        EKG: {
          ritmo: "",
          fc: "",
          ondaP: "",
          pr: "",
          qrs: "",
          ejeQRS: "",
          styt: "",
          qtc: "",
          professional: "",
          conclusions: "",
          medicament: {},
          addedMedicaments: [],
          file: null,
          cie: {
            code: "",
            name: ""
          }
        }
      },
      examResults: {
        results: "",
        notes: ""
      },
      sourceDocuments: [],
      loading: false,
      errors: {},
      stateClinicistory: "",
      openErrors: false
    };
  }


  componentDidMount() {

    this.setState({ stateClinicistory: this.props.data.estado }, () => {
      this.loadAnalysisAndMedicalPlan().then((load) => {
        console.log("cargar Analisis y plan medico!!");
      }).catch((error) => {
        console.log(error)
      });

      this.loadAnamesis().then((load) => {
        console.log("cargar anamesis !!");
      }).catch((error) => {
        console.log(error)
      });
      this.loadBackgroud().then((load) => {
        console.log("cargar Background !!");
      }).catch((error) => {
        console.log(error)
      });

      this.setState({ Diagnostic: { ...this.state.Diagnostic, load: true } }, () => {
        this.loadDiagnostic().then((load) => {
          console.log("cargar diagnostico !!");
          this.setState({ Diagnostic: { ...this.state.Diagnostic, load: false } })
        }).catch((error) => {
          console.log(error)
        });
      })

      this.setState({ MedicalOrders: { ...this.state.MedicalOrders, load: true } }, () => {
        this.loadMedicalOrders().then((load) => {
          console.log("cargar ordenes medicas !!");
          this.setState({ MedicalOrders: { ...this.state.MedicalOrders, load: false } }, () => {
            console.log(this.state.MedicalOrders);
          });
        }).catch((error) => {
          console.log(error)
        });
      })

      this.loadMedicalProcedures().then((load) => {
        console.log("cargar procedimientos medicos !!");
      }).catch((error) => {
        console.log(error)
      });

      this.setState({ PhysicalExam: { ...this.state.PhysicalExam, load: true } }, () => {
        this.loadPhysicalExam().then((load) => {
          console.log("cargar examenes fisicos !!");
          this.setState({ PhysicalExam: { ...this.state.PhysicalExam, load: false } });
        }).catch((error) => {
          console.log(error)
        });
      })

      this.setState({ SystemReview: { ...this.state.SystemReview, load: true } }, () => {
        this.loadSystemReview().then((load) => {
          console.log("cargar revisión del sistema !!");
          this.setState({ SystemReview: { ...this.state.SystemReview, load: false } })
        }).catch((error) => {
          console.log(error)
        });
      })
      this.loadDataTempletes();
      //console.log(this.state);
    });
  }

  toggle = (tab) => {
    const { activeTab } = this.state;
    if (activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  };

  loadDataTempletes = async () => {

    const id = sessionStorage.getItem('id_clinica');

    await fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-plantillas/consultar?id_clinica=' + id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.plantilla !== null) {

          this.setState({
            MedicalProcedures: {
              ECO: {
                description: data.plantilla.procedimientos.ECO.description,
                conclusions: data.plantilla.procedimientos.ECO.conclusions,
              },
              Stress: {
                description: data.plantilla.procedimientos.Stress.description,
                conclusions: data.plantilla.procedimientos.Stress.conclusions,
              },
              Test: {
                conclusion: data.plantilla.procedimientos.Test.conclusion,
                conclusions: data.plantilla.procedimientos.Test.conclusions,
              },
              Holter: {
                conclusion: data.plantilla.procedimientos.Holter.conclusion,
              },
              Map: {
                conclusion: data.plantilla.procedimientos.Map.conclusion,
              },
              EKG: {
                conclusions: data.plantilla.procedimientos.EKG.conclusions,
              }
            },
            SystemReview: {
              ailments: [
                { ailment: ailmentsSystemReview[0], commentary: data.plantilla.revision_por_sistema.sintomas_generales },
                { ailment: ailmentsSystemReview[1], commentary: data.plantilla.revision_por_sistema.respiratorios },
                { ailment: ailmentsSystemReview[2], commentary: data.plantilla.revision_por_sistema.cardio_vascular },
                { ailment: ailmentsSystemReview[3], commentary: data.plantilla.revision_por_sistema.gastrointestintal },
                { ailment: ailmentsSystemReview[4], commentary: data.plantilla.revision_por_sistema.genitourinario },
                { ailment: ailmentsSystemReview[5], commentary: data.plantilla.revision_por_sistema.osteomuscular },
                { ailment: ailmentsSystemReview[6], commentary: data.plantilla.revision_por_sistema.dermatologico },
                { ailment: ailmentsSystemReview[7], commentary: data.plantilla.revision_por_sistema.endocrino },
                { ailment: ailmentsSystemReview[8], commentary: data.plantilla.revision_por_sistema.neurologico },
              ]
            },
            examResults: {
              results: data.plantilla.resultados_examenes.results,
              notes: data.plantilla.resultados_examenes.notes
            },
          });
        }

      })
      .catch((error) => {
        console.error('Error:', error);

      });
  }


  handlerSelectCauseOfAdmission = (cause) => {
    this.setState({ anamesis: { ...this.state.anamesis, cause: cause } });
  }

  handlerReasonForConsultation = (reasonForConsultation) => {
    this.setState({ anamesis: { ...this.state.anamesis, reasonForConsultation: reasonForConsultation } });
  }

  handlerCurrentIllness = (currentIllness) => {
    this.setState({ anamesis: { ...this.state.anamesis, currentIllness: currentIllness } });
  }

  handlerCandidate = (candidate) => {

    if (candidate === "Sí")
      this.setState({ anamesis: { ...this.state.anamesis, candidate: true } });
    else
      this.setState({ anamesis: { ...this.state.anamesis, candidate: false } });

  }

  handlerParticipate = (participate) => {

    if (participate === "Sí")
      this.setState({ anamesis: { ...this.state.anamesis, participate: true } });
    else
      this.setState({ anamesis: { ...this.state.anamesis, participate: false } });
  }

  loadClinicHistory = () => {
    this.setState({ loading: true }, () => {
      Promise.all([
        this.loadAnamesis(),
        this.loadBackgroud(),
        this.loadDiagnostic(),
        this.loadMedicalOrders(),
        this.loadMedicalProcedures(),
        this.loadPhysicalExam(),
        this.loadSystemReview(),
      ])
        .then((results) => {
          this.setState({ serter: results[0], races: results[1], ethnicities: results[2], regimes: results[3], departments: results[4] }, () => {
            this.setState({ documentNumber: this.props.num_documento }, () => {
              this.loadDataPatient()
            });
          });
        }).catch((error) => {
          console.log(error);
        })
    })
  }


  loadAnamesis = () => {
    var data = {
      id_historia: this.props.data.id_historia,
      id_admision: this.props.data.id_admision,
    };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'anamnesis/consultar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(data)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          console.log(data);
          if (data.existe) {
            console.log(data.contenido);
            var anamesis = data.contenido[data.contenido.length - 1];
            this.setState({
              anamesis: {
                cause: anamesis.causa_ingreso,
                reasonForConsultation: anamesis.motivo_consulta,
                currentIllness: anamesis.enfermedad_actual,
                candidate: anamesis.candidato_estudio,
                study: anamesis.id_estudio,
                participate: anamesis.participa_estudio,
              }
            }, () => {
              var { dispatch } = this.props;
              dispatch(change("ananmesis-form", "cause-of-admission", { value: anamesis.causa_ingreso, label: anamesis.causa_ingreso }));
              dispatch(change("ananmesis-form", "textarea-reason-for-consultation", anamesis.motivo_consulta));
              dispatch(change("ananmesis-form", "textarea-current-illness", anamesis.enfermedad_actual));
              dispatch(change("ananmesis-form", "radio_button-candiate", anamesis.enfermedad_actual));
              dispatch(change("ananmesis-form", "acronym", anamesis.enfermedad_actual));
              dispatch(change("ananmesis-form", "radio_button-participate", anamesis.enfermedad_actual));
            });
            resolve(false);
          } else {
            console.log(data.contenido);
            resolve(false);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          reject(error);
        });
    })
  }

  loadBackgroud = () => {
    var data = {
      id_historia: this.props.data.id_historia,
      id_admision: this.props.data.id_admision,
    };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'antecedente/consultar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(data)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          console.log(data);
          if (data.existe) {
            console.log(data.contenido);
            var backgroundData = data.contenido;
            var ailments = this.state.sectionAilment.ailments;

            for (var sectionIndex = 0; sectionIndex < sectionMap.length; sectionIndex++) {
              var section = backgroundData[data.contenido.length - 1][sectionMap[sectionIndex]][sectionMap[sectionIndex]][0];
              //delete section.otros;
              var index = 0;
              console.log(section);
              console.log(ailments[sectionIndex][sections[sectionIndex]]);
              for (var val of Object.keys(section)) {
                console.log(ailments[sectionIndex][sections[sectionIndex]][index]);
                console.log(val);
                console.log(section[val]);
                if (ailments[sectionIndex][sections[sectionIndex]][index] != null && section[val] != null) {
                  ailments[sectionIndex][sections[sectionIndex]][index].value = section[val].value;
                  ailments[sectionIndex][sections[sectionIndex]][index].commentary = section[val].comentario;
                  index++;
                }
              }
            }

            var habitsData = backgroundData[data.contenido.length - 1].habitos.habitos[0];
            var habits = {};
            habits.packegesPerYear = habitsData.paquetes_anio;
            habits.years = habitsData.tiempo_anios;
            habits.cigarretsPerDay = habitsData.cigarillos_dia;
            habits.yearStart = habitsData.ano_inicio;
            habits.yearEnd = habitsData.ano_fin;
            habits.firewood = { value: habitsData.humo_lena, label: habitsData.humo_lena }; // { value: habitsData.humo_lena, label: habitsData.humo_lena }
            habits.smoke = { value: habitsData.fumador, label: habitsData.fumador }; // { value: habitsData.fumador, label: habitsData.furmador }
            habits.comsuption = { value: 'Si', label: 'Si' };
            habits.substace = habitsData.sustancia_psico;
            habits.frecuency = { value: habitsData.sustancia_frecuencia, label: habitsData.sustancia_frecuencia };
            habits.alcohol = { value: habitsData.alcohol, label: habitsData.alcohol }; //{ value: habitsData.alcohol, label: habitsData.alcohol };
            habits.alcoholLastYear = { value: habitsData.alcohol_ultimo_anio, label: habitsData.alcohol_ultimo_anio }; //{ value: habitsData.alcohol_ultimo_anio, label: habitsData.alcohol_ultimo_anio };
            habits.frecuencyAlcohol = { value: habitsData.alcohol_frecuencia, label: habitsData.alcohol_frecuencia };
            habits.physicalActivity = { value: habitsData.actividad_fisica, label: habitsData.actividad_fisica }; //{ value: habitsData.actividad_fisica, label: habitsData.actividad_fisica };
            habits.frecuencyPhysicalActivity = { value: habitsData.actividad_frecuencia, label: habitsData.actividad_frecuencia }; //{ value: habitsData.actividad_frecuencia, label: habitsData.actividad_frecuencia } ;
            habits.activities = habitsData.actividades_cuales;

            var substances = [];
            if (habitsData.bazuco === "Si") {
              substances.push({ value: "Bazuco", label: "Bazuco" });
            }
            if (habitsData.cocaina === "Si") {
              substances.push({ value: 'Cocaina', label: 'Cocaina' });
            }
            if (habitsData.extasis === "Si") {
              substances.push({ value: 'Extasis', label: 'Extasis' });
            }
            if (habitsData.extasis === "Si") {
              substances.push({ value: 'Heroina', label: 'Heroina' });
            }
            if (habitsData.hongos === "Si") {
              substances.push({ value: 'Hongos', label: 'Hongos' });
            }
            if (habitsData.lsd === "Si") {
              substances.push({ value: 'LSD', label: 'LSD' });
            }
            if (habitsData.marihuana === "Si") {
              substances.push({ value: 'Marihuana', label: 'Marihuana' });
            }
            if (habitsData.ghb === "Si") {
              substances.push({ value: 'GHB', label: 'GHB' });
            }
            habits.substaces = substances;

            this.setState({ sectionAilment: { ...this.state.sectionAilment, ailments: ailments, habits: habits } }, () => {
              var { dispatch } = this.props;
              dispatch(change("habits_form", "select-smoke", { value: habitsData.fumador, label: habitsData.furmador }));
              dispatch(change("habits_form", "PackegesPerYear", habits.packegesPerYear));
              dispatch(change("habits_form", "select-firewood", { value: habitsData.humo_lena, label: habitsData.humo_lena }));
              dispatch(change("habits_form", "yearsExpose", habitsData.tiempo_anios));
              dispatch(change("habits_form", "select-comsuption-substances", { value: "Si", label: "Si" }));

              dispatch(change("habits_form", "multiSelect-subtances", substances));
              dispatch(change("habits_form", "frecuency-of-consumption", { value: habitsData.sustancia_frecuencia, label: habitsData.sustancia_frecuencia }));
              dispatch(change("habits_form", "another-substance", habitsData.sustancia_psico));

              dispatch(change("habits_form", "alcohol-select", { value: habitsData.alcohol, label: habitsData.alcohol }));
              dispatch(change("habits_form", "alcohol-last-year-select", { value: habitsData.alcohol_ultimo_anio, label: habitsData.alcohol_ultimo_anio }));
              dispatch(change("habits_form", "frecuency-of-consumption-alcohol", { value: habitsData.alcohol_frecuencia, label: habitsData.alcohol_frecuencia }));
              dispatch(change("habits_form", "physical-activity-select", { value: habitsData.actividad_fisica, label: habitsData.actividad_fisica }));
              dispatch(change("habits_form", "frecuency-physical-activity", { value: habitsData.actividad_frecuencia, label: habitsData.actividad_frecuencia }));
              dispatch(change("habits_form", "textarea-another-physical-activies", habitsData.actividades_cuales));
            });
            resolve(false);
          } else {
            console.log(data.contenido);

            resolve(false);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          reject(error);
        });
    })
  }

  loadSystemReview = () => {
    var data = {
      id_historia: this.props.data.id_historia,
      id_admision: this.props.data.id_admision,
    };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'sistemas/consultar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(data)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (data.existe) {
            console.log(data);
            var systemReview = data.contenido[data.contenido.length - 1];
            this.setState({
              SystemReview: {
                ailments: [
                  { ailment: ailmentsSystemReview[0], commentary: systemReview.sintomas_generales },
                  { ailment: ailmentsSystemReview[1], commentary: systemReview.respiratorio },
                  { ailment: ailmentsSystemReview[2], commentary: systemReview.cardiovascular },
                  { ailment: ailmentsSystemReview[3], commentary: systemReview.gastrointestinal },
                  { ailment: ailmentsSystemReview[4], commentary: systemReview.genitourinario },
                  { ailment: ailmentsSystemReview[5], commentary: systemReview.osteomuscular },
                  { ailment: ailmentsSystemReview[6], commentary: systemReview.dermatologico },
                  { ailment: ailmentsSystemReview[7], commentary: systemReview.endocrino },
                  { ailment: ailmentsSystemReview[8], commentary: systemReview.neurologico },
                ]
              }
            }, () => {
              var { dispatch } = this.props;
              dispatch(change("system-review-form", "comment-Síntomas Generales", systemReview.sintomas_generales));
              dispatch(change("system-review-form", "comment-Respiratorios", systemReview.respiratorio));
              dispatch(change("system-review-form", "comment-Cardiovascular", systemReview.cardiovascular));
              dispatch(change("system-review-form", "comment-Gastrointestinal", systemReview.gastrointestinal));
              dispatch(change("system-review-form", "comment-Genitourinario", systemReview.genitourinario));
              dispatch(change("system-review-form", "comment-Osteomuscular", systemReview.osteomuscular));
              dispatch(change("system-review-form", "comment-Dermatologico", systemReview.dermatologico));
              dispatch(change("system-review-form", "comment-Endocrino", systemReview.endocrino));
              dispatch(change("system-review-form", "comment-Neurologico", systemReview.neurologico));
            });
            resolve(false);
          } else {
            console.log(data.contenido);
            resolve(false);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          reject(error);
        });
    })
  }

  loadPhysicalExam = () => {
    var data = {
      id_historia: this.props.data.id_historia,
      id_admision: this.props.data.id_admision,
    };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'fisico/consultar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(data)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          console.log(data);
          if (data.existe) {
            var physicalExam = data.contenido[data.contenido.length - 1];
            console.log(physicalExam);
            this.setState({
              PhysicalExam: {
                gender: physicalExam.genero,
                weight: physicalExam.peso,
                abdominalPerimeter: physicalExam.peri_abdominal,
                size: physicalExam.talla,
                heartRate: physicalExam.frecuencia_cardiaca,
                breathingFrequency: physicalExam.frecuencia_respiratoria,
                temperature: physicalExam.temperatura,
                bloodPressure: physicalExam.presion_arterial,
                BMI: physicalExam.masa_corporal,
                bodySurface: physicalExam.superficie_corporal,
                dominance: physicalExam.dominancia,
                generalFeatures: physicalExam.aspecto_general,
                headAndFace: physicalExam.cabeza_cara,
                ori: physicalExam.ori,
                eyes: physicalExam.ojos,
                neck: physicalExam.cuello,
                chest: physicalExam.torax,
                cardioVascular: physicalExam.cardiovascular,
                pulmonary: physicalExam.pulmonar,
                abdomen: physicalExam.abdomen,
                limbs: physicalExam.extremidades,
                neurological: physicalExam.neurologico,
                genitourinary: physicalExam.genitourinario,
                skin_appendages: physicalExam.piel_faneras,
                otorhino: physicalExam.otorrino
              }
            }, () => {
              var { dispatch } = this.props;
              dispatch(change("physical-exam-form", "select-gender", { value: physicalExam.genero, label: physicalExam.genero }));
              dispatch(change("physical-exam-form", "comment-weight", physicalExam.peso));
              dispatch(change("physical-exam-form", "abdominal-perimeter", physicalExam.peri_abdominal));
              dispatch(change("physical-exam-form", "size", physicalExam.talla));
              dispatch(change("physical-exam-form", "body-mass-index", physicalExam.masa_corporal));
              dispatch(change("physical-exam-form", "select-dominance", { value: physicalExam.dominancia, label: physicalExam.dominancia }));
              dispatch(change("physical-exam-form", "heart-rate", physicalExam.frecuencia_cardiaca));
              dispatch(change("physical-exam-form", "breathing-frequency", physicalExam.frecuencia_respiratoria));
              dispatch(change("physical-exam-form", "temperature", physicalExam.temperatura));
              dispatch(change("physical-exam-form", "blood-pressure", physicalExam.presion_arterial));
              dispatch(change("physical-exam-form", "textarea-general-features", physicalExam.aspecto_general));
              dispatch(change("physical-exam-form", "textarea-head-face", physicalExam.cabeza_cara));
              dispatch(change("physical-exam-form", "textarea-ori", physicalExam.ori));
              dispatch(change("physical-exam-form", "textarea-eyes", physicalExam.ojos));
              dispatch(change("physical-exam-form", "textarea-neck", physicalExam.cuello));
              dispatch(change("physical-exam-form", "textarea-chest", physicalExam.torax));
              dispatch(change("physical-exam-form", "textarea-cardiovascular", physicalExam.cardiovascular));
              dispatch(change("physical-exam-form", "textarea-pulmonary", physicalExam.pulmonar));
              dispatch(change("physical-exam-form", "textarea-abdomen", physicalExam.abdomen));
              dispatch(change("physical-exam-form", "textarea-limbs", physicalExam.extremidades));
              dispatch(change("physical-exam-form", "textarea-neurological", physicalExam.ojos));
              dispatch(change("physical-exam-form", "textarea-genitourinary", physicalExam.neurologico));
              dispatch(change("physical-exam-form", "textarea-skin-appendages", physicalExam.piel_faneras));
              dispatch(change("physical-exam-form", "textarea-otorhino", physicalExam.otorrino));
            });
            resolve(false);
          } else {
            console.log(data.contenido);
            resolve(false);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          reject(error);
        });
    })
  }

  loadDiagnostic = () => {
    var data = {
      id_historia: this.props.data.id_historia,
      id_admision: this.props.data.id_admision,
    };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'diagadmision/consultar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(data)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          console.log("diagnostico:");
          console.log(data);
          if (data.existe) {
            var diagnostic = data.contenido[data.contenido.length - 1].diagnostico.diagnostico;
            console.log(diagnostic);
            this.setState({
              Diagnostic: {
                ...this.state.Diagnostic,
                dataOldDiagnostic: diagnostic
              }
            }, () => {
              var { dispatch } = this.props;
              dispatch(change("diagnostic-form", "comment-Síntomas Generales", diagnostic.sintomas_generales));
              dispatch(change("diagnostic-form", "comment-Respiratorios", diagnostic.respiratorio));
            });
            resolve(false);
          } else {
            console.log(data.contenido);
            resolve(false);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          reject(error);
        });
    })
  }

  loadAnalysisAndMedicalPlan = () => {
    var data = {
      id_historia: this.props.data.id_historia,

    };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'planmedico/consultar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(data)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (data.existe) {

            console.log(data.contenido);
            console.log("cargar analisis y plan medico !!");
            var analysisAndMedicalPlan = data.contenido[data.contenido.length - 1];
            this.setState({
              AnalysisAndMedicalPlan: {
                analysis: analysisAndMedicalPlan.analisis,
                plan: analysisAndMedicalPlan.plan_medico,
                recommendations: analysisAndMedicalPlan.recomendaciones
              }
            }, () => {
              var { dispatch } = this.props;
              dispatch(change("analysis-and-medical-plan-form", "textarea-analysis", analysisAndMedicalPlan.analisis));
              dispatch(change("analysis-and-medical-plan-form", "textarea-medical-plan", analysisAndMedicalPlan.plan_medico));
              dispatch(change("analysis-and-medical-plan-form", "textarea-recommendations", analysisAndMedicalPlan.recomendaciones));
            });
            resolve(false);
          } else {
            console.log(data.contenido);
            resolve(false);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          reject(error);
        });
    })
  }

  loadMedicalOrders = () => {
    var data = {
      id_historia: this.props.data.id_historia,
      id_admision: this.props.data.id_admision,
    };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'tratadmision/consultar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(data)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (data.existe) {
            var tratamientos = data.contenido[0];
            console.log(tratamientos);
            console.log({
              MedicalOrders: {
                observations: [],
                formulas: tratamientos.tratamiento.tratamiento.map((tratamiento) => {
                  var nuevoTratamiento = {};
                  nuevoTratamiento.concentration = tratamiento.concentracion;
                  nuevoTratamiento.activePrinciple = tratamiento.principio_activo;
                  nuevoTratamiento.dose = tratamiento.dosis;
                  nuevoTratamiento.route = tratamiento.via_administracion;
                  nuevoTratamiento.pharmaceuticalForm = tratamiento.forma_farmaceutica;
                  nuevoTratamiento.frequency = tratamiento.frecuencia;
                  nuevoTratamiento.duration = tratamiento.duracion;
                  nuevoTratamiento.units = tratamiento.unidades_requeridas;
                  return nuevoTratamiento;
                })
              }
            });
            this.setState({
              MedicalOrders: {
                ...this.state.MedicalOrders,
                observations: [],
                addedDiagnostics: data.contenido[0].ordenes.ordenes.addedDiagnostics,
                formulas: tratamientos.tratamiento.tratamiento.map((tratamiento) => {
                  var nuevoTratamiento = {};
                  nuevoTratamiento.activePrinciple = tratamiento.principio_activo;
                  nuevoTratamiento.concentration = tratamiento.concentracion;
                  nuevoTratamiento.dose = tratamiento.dosis;
                  nuevoTratamiento.route = tratamiento.via_administracion;
                  nuevoTratamiento.pharmaceuticalForm = tratamiento.forma_farmaceutica;
                  nuevoTratamiento.frequency = tratamiento.frecuencia;
                  nuevoTratamiento.duration = tratamiento.duracion;
                  nuevoTratamiento.units = tratamiento.unidades_requeridas;
                  return nuevoTratamiento;
                })
              }
            }, () => {

              //var { dispatch } = this.props;
              //dispatch(change("analysis-and-medical-plan-form", "textarea-analysis", analysisAndMedicalPlan.analisis));
              //dispatch(change("analysis-and-medical-plan-form", "textarea-medical-plan", analysisAndMedicalPlan.plan_medico));
              //dispatch(change("analysis-and-medical-plan-form", "textarea-recommendations", analysisAndMedicalPlan.recomendaciones));
            });
            resolve(false);
          } else {
            console.log(data.contenido);
            resolve(false);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          reject(error);
        });
    })
  }

  getDataFiles = () => {

    let dataSend = {
      id_historia: parseInt(this.props.data.id_historia),
      id_admision: parseInt(this.props.data.id_admision)
    };

    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'archivos/consultar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(dataSend)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          console.log(data.contenido[0].archivos);
          if (data.existe) {
            this.setState({
              sourceDocuments: data.contenido[0].archivos
            });

          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    })

  }


  loadMedicalProcedures = () => {
    var data = {
      id_historia: this.props.data.id_historia,
      id_admision: this.props.data.id_admision,
    };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'procedimientos/consultar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(data)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (data.existe) {
            var procedures = data.contenido[0];
            console.log(procedures);
            this.setState({
              MedicalProcedures: {
                ...this.state.MedicalProcedures,
                ECO: {
                  ...this.state.MedicalProcedures.ECO,
                  vid: procedures.eco.eco[0].vid,
                  rao: procedures.eco.eco[0].rao,
                  e: procedures.eco.eco[0].e,
                  pp: procedures.eco.eco[0].pp,
                  ao: procedures.eco.eco[0].anillo_ao,
                  a: procedures.eco.eco[0].a,
                  ps: procedures.eco.eco[0].ps,
                  vd: procedures.eco.eco[0].vd,
                  tapse: procedures.eco.eco[0].tap_se,
                  vis: procedures.eco.eco[0].vis,
                  ai: procedures.eco.eco[0].ai,
                  ad: procedures.eco.eco[0].ad,
                  fe: procedures.eco.eco[0].fe,
                  description: procedures.eco.eco[0].descripcion,
                  conclusions: procedures.eco.eco[0].conclusiones,
                  professional: procedures.eco.eco[0].profesional,
                  addedMedicaments: procedures.eco.eco[0].diagnostico,
                },
                Stress: {
                  ...this.state.MedicalProcedures.Stress,
                  vid: procedures.estres.estres[0].vid,
                  rao: procedures.estres.estres[0].rao,
                  e: procedures.estres.estres[0].e,
                  pp: procedures.estres.estres[0].pp,
                  ao: procedures.estres.estres[0].ao,
                  a: procedures.estres.estres[0].a,
                  ps: procedures.estres.estres[0].ps,
                  vd: procedures.estres.estres[0].vd,
                  tapse: procedures.estres.estres[0].tap_se,
                  vis: procedures.estres.estres[0].vis,
                  ai: procedures.estres.estres[0].ai,
                  ad: procedures.estres.estres[0].ad,
                  fe: procedures.estres.estres[0].fe,
                  adult: {},
                  conclusions: procedures.estres.estres[0].conclusiones,
                  professional: procedures.estres.estres[0].professional,
                  addedMedicaments: procedures.estres.estres[0].diagnostico,
                  observations: []
                },
                Test: {
                  ...this.state.MedicalProcedures.Test,
                  professional: procedures.prueba.prueba[0].profesional,
                  conclusion: procedures.prueba.prueba[0].conlusion,
                  conclusions: procedures.prueba.prueba[0].conclusiones,
                  addedMedicaments: procedures.prueba.prueba[0].diagnostico,
                },
                Holter: {
                  ...this.state.MedicalProcedures.Holter,
                  professional: procedures.holter.holter[0].profesional,
                  conclusion: procedures.holter.holter[0].conlusion,
                  addedMedicaments: procedures.holter.holter[0].diagnostico,
                },
                Map: {
                  ...this.state.MedicalProcedures.Map,
                  professional: procedures.mapa.mapa[0].profesional,
                  conclusion: procedures.mapa.mapa[0].conclusion,
                  addedMedicaments: procedures.mapa.mapa[0].diagnostico,
                },
                EKG: {
                  ...this.state.MedicalProcedures.EKG,
                  fc: procedures.ekg.ekg[0].fc,
                  ejeQRS: procedures.ekg.ekg[0].eje_qrs,
                  ondaP: procedures.ekg.ekg[0].onda_p,
                  pr: procedures.ekg.ekg[0].pr,
                  qrs: procedures.ekg.ekg[0].qr_s,
                  //qtc: procedures.ekg.ekg[0].qtc,
                  //styt: procedures.ekg.ekg[0].styt,
                  ritmo: procedures.ekg.ekg[0].ritmo,
                  conclusions: procedures.ekg.ekg[0].conclusion,
                  professional: procedures.ekg.ekg[0].profesional,
                  addedMedicaments: procedures.ekg.ekg[0].diagnostico,
                }
              }
            }, () => {
              var { dispatch } = this.props;
              dispatch(change("medical-procedures-form", "VID-ECO", procedures.eco.eco[0].vid));
              dispatch(change("medical-procedures-form", "RAO-ECO", procedures.eco.eco[0].rao));
              dispatch(change("medical-procedures-form", "E-ECO", procedures.eco.eco[0].e));
              dispatch(change("medical-procedures-form", "PP-ECO", procedures.eco.eco[0].pp));
              dispatch(change("medical-procedures-form", "ANILLO-AO-ECO", procedures.eco.eco[0].anillo_ao));
              dispatch(change("medical-procedures-form", "A-ECO", procedures.eco.eco[0].a));
              dispatch(change("medical-procedures-form", "PS-ECO", procedures.eco.eco[0].a));
              dispatch(change("medical-procedures-form", "VD-ECO", procedures.eco.eco[0].vd));
              dispatch(change("medical-procedures-form", "TAPSE-ECO", procedures.eco.eco[0].tap_se));
              dispatch(change("medical-procedures-form", "VIS-ECO", procedures.eco.eco[0].tap_se));
              dispatch(change("medical-procedures-form", "AI-ECO", procedures.eco.eco[0].ai));
              dispatch(change("medical-procedures-form", "AD-ECO", procedures.eco.eco[0].ad));
              dispatch(change("medical-procedures-form", "FE-ECO", procedures.eco.eco[0].fe));
              dispatch(change("medical-procedures-form", "select-adult-ECO", { value: procedures.eco.eco[0].adulto, label: procedures.eco.eco[0].adulto }));
              dispatch(change("medical-procedures-form", "textarea-description-ECO", procedures.eco.eco[0].descripcion));
              dispatch(change("medical-procedures-form", "textarea-conclusions-ECO", procedures.eco.eco[0].conclusiones));

              dispatch(change("medical-procedures-form", "VID-STRESS", procedures.estres.estres[0].vid));
              dispatch(change("medical-procedures-form", "RAO-STRESS", procedures.estres.estres[0].rao));
              dispatch(change("medical-procedures-form", "E-STRESS", procedures.estres.estres[0].e));
              dispatch(change("medical-procedures-form", "PP-STRESS", procedures.estres.estres[0].pp));
              dispatch(change("medical-procedures-form", "ANILLO-AO-STRESS", procedures.estres.estres[0].anillo_ao));
              dispatch(change("medical-procedures-form", "A-STRESS", procedures.estres.estres[0].a));
              dispatch(change("medical-procedures-form", "PS-STRESS", procedures.estres.estres[0].a));
              dispatch(change("medical-procedures-form", "VD-STRESS", procedures.estres.estres[0].vd));
              dispatch(change("medical-procedures-form", "TAPSE-STRESS", procedures.estres.estres[0].tap_se));
              dispatch(change("medical-procedures-form", "VIS-STRESS", procedures.estres.estres[0].tap_se));
              dispatch(change("medical-procedures-form", "AI-STRESS", procedures.estres.estres[0].ai));
              dispatch(change("medical-procedures-form", "AD-STRESS", procedures.estres.estres[0].ad));
              dispatch(change("medical-procedures-form", "FE-STRESS", procedures.estres.estres[0].fe));
              dispatch(change("medical-procedures-form", "select-adult-STRESS", { value: procedures.estres.estres[0].adulto, label: procedures.estres.estres[0].adulto }));
              dispatch(change("medical-procedures-form", "textarea-conclusions-STRESS", procedures.estres.estres[0].conclusiones));

              dispatch(change("medical-procedures-form", "textarea-conclusion-HOLTER", procedures.holter.holter[0].conclusion));

              dispatch(change("medical-procedures-form", "textarea-conclusion-MAP", procedures.mapa.mapa[0].conclusion));

              dispatch(change("medical-procedures-form", "RITMO-EKG", procedures.ekg.ekg[0].ritmo));
              dispatch(change("medical-procedures-form", "FC-EKG", procedures.ekg.ekg[0].fc));
              dispatch(change("medical-procedures-form", "ONDA-P-EKG", procedures.ekg.ekg[0].onda_p));
              dispatch(change("medical-procedures-form", "PR-EKG", procedures.ekg.ekg[0].pr));
              dispatch(change("medical-procedures-form", "QRS-EKG", procedures.ekg.ekg[0].qr_s));
              dispatch(change("medical-procedures-form", "EJE-QRS-EKG", procedures.ekg.ekg[0].eje_qrs));
              dispatch(change("medical-procedures-form", "ST-EKG", ""));
              dispatch(change("medical-procedures-form", " QTc-EKG", ""));
              dispatch(change("medical-procedures-form", "textarea-conclusion-EKG", procedures.ekg.ekg[0].conclusion));

              //dispatch(change("analysis-and-medical-plan-form", "textarea-medical-plan", analysisAndMedicalPlan.plan_medico));
              //dispatch(change("analysis-and-medical-plan-form", "textarea-recommendations", analysisAndMedicalPlan.recomendaciones));
            });
            resolve(false);
          } else {
            console.log(data.contenido);
            resolve(false);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          reject(error);
        });
    })
  }

  handlerAilment = (ailment, section, sectionIndex, index) => {
    var ailments = this.state.sectionAilment.ailments;
    ailments[sectionIndex][section][index] = { ...ailments[sectionIndex][section][index], value: ailment };
    this.setState({ sectionAilment: { ...this.state.sectionAilment, ailments: ailments } });
  }

  handlerCommentary = (commentary, section, sectionIndex, index) => {
    var ailments = this.state.sectionAilment.ailments;
    ailments[sectionIndex][section][index] = { ...ailments[sectionIndex][section][index], commentary: commentary };
    this.setState({ sectionAilment: { ...this.state.sectionAilment, ailments: ailments } });
  }

  handlerAlimentDate = (date, section, sectionIndex, index) => {

    var ailments = this.state.sectionAilment.ailments;
    ailments[sectionIndex][section][index] = { ...ailments[sectionIndex][section][index], date: date };
    this.setState({ sectionAilment: { ...this.state.sectionAilment, ailments: ailments } });

  }
  handlerAlimentTable = (table, section, sectionIndex, index) => {

    var ailments = this.state.sectionAilment.ailments;
    ailments[sectionIndex][section][index] = { ...ailments[sectionIndex][section][index], table: table };
    this.setState({ sectionAilment: { ...this.state.sectionAilment, ailments: ailments } });
    console.log(index);

  }


  handlerComments = (commentary, sectionIndex) => {
    var commentary = this.state.sectionAilment.commentary;
    commentary[sectionIndex] = commentary;
    this.setState({ sectionAilment: { ...this.state.sectionAilment, commentary: commentary } })
  }

  handlerCommentsSystemReview = (commentary, index) => {
    var ailments = this.state.SystemReview.ailments;
    ailments[index].commentary = commentary;
    this.setState({ SystemReview: { ailments: ailments } });
  }

  handlerAnalysis = (analysis) => {
    this.setState({ AnalysisAndMedicalPlan: { ...this.state.AnalysisAndMedicalPlan, analysis: analysis } });
  }

  handlerPlan = (plan) => {
    this.setState({ AnalysisAndMedicalPlan: { ...this.state.AnalysisAndMedicalPlan, plan: plan } });
  }

  handlerRecommendations = (recommendations) => {
    this.setState({ AnalysisAndMedicalPlan: { ...this.state.AnalysisAndMedicalPlan, recommendations: recommendations } });
  }

  handlerPlanificacion = (label, value) => {

    this.setState({ sectionAilment: { ...this.state.sectionAilment, planification: { ...this.state.sectionAilment.planification, [label]: value } } });
  }

  handlerHabits = (habit, valueHabit) => {
    console.log({ sectionAilment: { ...this.state.sectionAilment, habits: { ...this.state.sectionAilment.habits, [habit]: valueHabit } } });
    this.setState({ sectionAilment: { ...this.state.sectionAilment, habits: { ...this.state.sectionAilment.habits, [habit]: valueHabit } } });
  }


  handlerPhysicalExam = (physicalName, value) => {
    console.log(value);
    this.setState({ PhysicalExam: { ...this.state.PhysicalExam, [physicalName]: value } });
  }

  handlerWeight = (weight) => {
    this.setState({ PhysicalExam: { ...this.state.PhysicalExam, weight: weight } }, () => {
      this.caculateBMIandSurfaceBody();
    });
  }

  handlerSize = (size) => {
    this.setState({ PhysicalExam: { ...this.state.PhysicalExam, size: size } }, () => {
      this.caculateBMIandSurfaceBody();
    });
  }

  calculateSurfaceBody = () => {
    var SC = Math.sqrt(((this.state.PhysicalExam.weight) * (this.state.PhysicalExam.size)) / 3600);
    this.setState({ PhysicalExam: { ...this.state.PhysicalExam, bodySurface: SC } })
  }

  caculateBMIandSurfaceBody = () => {
    if ((this.state.PhysicalExam.weight !== "" && this.state.PhysicalExam.weight !== 0) && (this.state.PhysicalExam.size !== "" && this.state.PhysicalExam.size !== 0)) {
      var BMI = (this.state.PhysicalExam.weight / (Math.pow(this.state.PhysicalExam.size, 2))).toFixed(4);
      var SC = (Math.sqrt(((this.state.PhysicalExam.weight) * (this.state.PhysicalExam.size)) / 3600)).toFixed(4);
      this.setState({ PhysicalExam: { ...this.state.PhysicalExam, BMI: BMI, bodySurface: SC } });
    }
  }

  handlerCUPS = (cups) => {
    this.setState({ Diagnostic: { ...this.state.Diagnostic, cups: cups } });
  }

  handlerDiagnosticName = (name) => {
    this.setState({ Diagnostic: { ...this.state.Diagnostic, name: name } });
  }

  handlerMedicalOrdersCUPS = (cups) => {
    this.setState({ MedicalOrders: { ...this.state.MedicalOrders, cups: cups } });
  }

  handlerMedicalOrdersDiagnosticName = (name) => {
    this.setState({ MedicalOrders: { ...this.state.MedicalOrders, name: name } });
  }

  handlerAddObservationDiagnostic = (index, observation) => {
    var observations = this.state.Diagnostic.observations
    observations[index] = observation;
    this.setState({ Diagnostic: { ...this.state.Diagnostic, observations: observations } });
  }

  handlerAddObservation = (index, observation) => {
    var observations = this.state.MedicalOrders.observations;
    observations[index] = observation;
    this.setState({ MedicalOrders: { ...this.state.MedicalOrders, observations: observations } });
  }

  handlerMedicalOrderTime = (time) => {
    this.setState({ MedicalOrders: { ...this.state.MedicalOrders, time: time } });
  }

  searchMedicalOrders = () => {
    var data = {
      cupscod: this.state.MedicalOrders.cups,
      cupsnom: this.state.MedicalOrders.name
    };
    console.log(data);
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'cups/consultar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(data)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          console.log(data);
          if (data.existe) {
            resolve(data.contenido);
          } else {
            alert(data.contenido);
            resolve([]);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          resolve(error);
        });
    })
  };

  searchDiagnostic = (name, cups) => {
    this.setState({ Diagnostic: { ...this.state.Diagnostic, name: name, cups: cups } });

    var data = {
      cupscod: cups,
      cupsnom: name
    };
    //console.log(data);

    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'cups/consultar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(data)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          //console.log(data);
          if (data.existe) {
            resolve(data.contenido);
          } else {
            resolve([]);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          resolve(error);
        });
    })
  };

  searchCIE = (name, code) => {
    this.setState({ Diagnostic: { ...this.state.Diagnostic, codigo: code, nombre: name } });

    var data = {
      codigo: code.toUpperCase(),
      nombre: name
    };
    //console.log(data);

    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'cie10/consultar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(data)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          //console.log(data);
          if (data.existe) {
            resolve(data.contenido);
          } else {
            resolve([]);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          resolve(error);
        });
    })
  };

  searchMedicaments = (name) => {

    var data = {
      principio_activo: name
    };

    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'medicamento/consultar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(data)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          console.log(data);
          if (data.existe) {
            resolve(data.contenido);
          } else {
            resolve([]);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          resolve(error);
        });
    })
  };

  searchMedications = (section, name, code) => {
    console.log(this.state.MedicalProcedures[section]);
    var data = {
      codigo: code, //this.state.MedicalProcedures[section].cie.code,
      nombre: name //this.state.MedicalProcedures[section].cie.name
    };
    console.log(data);
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'medidci/consultar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(data)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          console.log(data);
          if (data.existe) {
            resolve(data.contenido);
          } else {
            resolve([]);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          resolve(error);
        });
    })
  }

  selectDiagnostic = (diagnostic) => {
    this.setState({ Diagnostic: { ...this.state.Diagnostic, diagnostic: diagnostic } });
  }

  selectMedicament = (section, medicament) => {
    this.setState({ MedicalProcedures: { ...this.state.MedicalProcedures, [section]: { ...this.state.MedicalProcedures[section], medicament: medicament } } });
  }

  selectMedicalOrdersDiagnostic = (diagnostic) => {
    this.setState({ MedicalOrders: { ...this.state.MedicalOrders, diagnostic: diagnostic } });
  }

  addDiagnostic = (diagnostic) => {
    this.setState({ Diagnostic: { ...this.state.Diagnostic, addedDiagnostics: [...this.state.Diagnostic.addedDiagnostics, diagnostic] } });
  }

  addMedicament = (section, medicament) => {
    this.setState({ MedicalProcedures: { ...this.state.MedicalProcedures, [section]: { ...this.state.MedicalProcedures[section], addedMedicaments: [...this.state.MedicalProcedures[section].addedMedicaments, medicament] } } });
  }

  removeDiagnostic = (index) => {
    var addedDiagnostics = this.state.Diagnostic.addedDiagnostics;
    addedDiagnostics = addedDiagnostics.filter((value, indexDiag) => {
      return indexDiag !== index;
    });
    var observations = this.state.Diagnostic.observations;
    observations = observations.filter((value, indexDiag) => {
      return indexDiag !== index;
    });
    this.setState({ Diagnostic: { ...this.state.Diagnostic, addedDiagnostics: addedDiagnostics, observations: observations } });
  }

  removeMedicament = (section, index) => {
    var addedMedicaments = this.state.MedicalProcedures[section].addedMedicaments;
    addedMedicaments = addedMedicaments.filter((value, indexDiag) => {
      return indexDiag !== index;
    });
    this.setState({ MedicalProcedures: { ...this.state.MedicalProcedures, [section]: { ...this.state.MedicalProcedures[section], addedMedicaments: addedMedicaments } } });
  }

  addMedicalOrderDiagnostic = (diagnostic) => {
    this.setState({ MedicalOrders: { ...this.state.MedicalOrders, addedDiagnostics: [...this.state.MedicalOrders.addedDiagnostics, diagnostic] } });
  }

  removeMedicalOrderDiagnostic = (index) => {
    var addedDiagnostics = this.state.MedicalOrders.addedDiagnostics;
    addedDiagnostics = addedDiagnostics.filter((value, indexDiag) => {
      return indexDiag !== index;
    });
    var observations = this.state.MedicalOrders.observations;
    console.log(observations);
    observations = observations.filter((value, indexDiag) => {
      return indexDiag !== index;
    });
    this.setState({ MedicalOrders: { ...this.state.MedicalOrders, addedDiagnostics: addedDiagnostics, observations: observations } });
  }

  handlerFormulasNew = (formula, reset) => {
    var formulas = this.state.MedicalOrders.formulas;
    formulas.push(formula);
    this.setState({ MedicalOrders: { ...this.state.MedicalOrders, formulas: formulas } }, () => {
      reset();
    });
  }

  removeFormula = () => {
    var formulas = this.state.MedicalOrders.formulas;
    formulas.pop();
    this.setState({ MedicalOrders: { ...this.state.MedicalOrders, formulas: formulas } });
  }

  handlerMedicalProcedures = (section, variable, value) => {
    this.setState({ MedicalProcedures: { ...this.state.MedicalProcedures, [section]: { ...this.state.MedicalProcedures[section], [variable]: value } } });
  }

  handlerMedications = (section, variable, value) => {
    this.setState({ MedicalProcedures: { ...this.state.MedicalProcedures, [section]: { ...this.state.MedicalProcedures[section], cie: { ...this.state.MedicalProcedures[section].cie, [variable]: value } } } });
  }

  validateClinicHistory = () => {
    var errors = {
      anamesis: {},
      analysisAndMedicalPlan: {}
    };

    if (!this.state.anamesis.cause) {
      errors.anamesis.cause = "Ingrese un anamesis";
    } else {
      delete errors.anamesis.cause;
    }

    if (!this.state.anamesis.reasonForConsultation) {
      errors.anamesis.reasonForConsultation = "Ingrese la razón de la consulta";
    } else {
      delete errors.anamesis.reasonForConsultation;
    }

    if (!this.state.anamesis.currentIllness) {
      errors.anamesis.currentIllness = "Ingrese la enfermedad actual";
    } else {
      delete errors.anamesis.currentIllness;
    }

    if (Object.keys(errors.anamesis).length === 0) {
      delete errors.anamesis;
    }

    if (!this.state.AnalysisAndMedicalPlan.analysis) {
      errors.analysisAndMedicalPlan.analysis = "Ingrese un analisis";
    } else {
      delete errors.analysisAndMedicalPlan.analysis;
    }

    if (!this.state.AnalysisAndMedicalPlan.plan) {
      errors.analysisAndMedicalPlan.plan = "Ingrese un plan";
    } else {
      delete errors.analysisAndMedicalPlan.plan;
    }

    if (!this.state.AnalysisAndMedicalPlan.recommendations) {
      errors.analysisAndMedicalPlan.recommendations = "Ingrese las recomendaciones";
    } else {
      delete errors.analysisAndMedicalPlan.recommendations;
    }

    if (Object.keys(errors.analysisAndMedicalPlan).length === 0) {
      delete errors.analysisAndMedicalPlan;
    }

    this.setState({ errors: errors, openErrors: Object.keys(errors).length > 0 });

    if (Object.keys(errors).length > 0) {
      return true;
    } else {
      return false;
    }

  }

  createHistory = () => {
    this.setState({ btnActive: false });
    if (!this.validateClinicHistory()) {
      var patologicos = {};
      this.state.sectionAilment.ailments[0].patologicos.map((ailment, index) => {
        switch (index) {
          case 0:
            patologicos.hipetension = { value: ailment.value, comentario: ailment.commentary, fecha: ailment.date };
            break;
          case 1:
            patologicos.metabolicos = { value: ailment.value, comentario: ailment.commentary, fecha: ailment.date };
            break;
          case 2:
            patologicos.cardiacos = { value: ailment.value, comentario: ailment.commentary, fecha: ailment.date };
            break;
          case 3:
            patologicos.infecciosos = { value: ailment.value, comentario: ailment.commentary, fecha: ailment.date };
            break;
          case 4:
            patologicos.vasculares = { value: ailment.value, comentario: ailment.commentary, fecha: ailment.date };
            break;
          case 5:
            patologicos.alergicos = { value: ailment.value, comentario: ailment.commentary, fecha: ailment.date };
            break;
          case 6:
            patologicos.cancer = { value: ailment.value, comentario: ailment.commentary, fecha: ailment.date };
            break;
          case 7:
            patologicos.transfusiones = { value: ailment.value, comentario: ailment.commentary, fecha: ailment.date };
            break;
          case 8:
            patologicos.autoinmunes = { value: ailment.value, comentario: ailment.commentary, fecha: ailment.date };
            break;
          case 9:
            patologicos.traumatico = { value: ailment.value, comentario: ailment.commentary, fecha: ailment.date };
            break;
          //["Hipertensión","Metabólicos", "Cardiacos", "Infecciosos", "Vasculares", "Alérgicos", "Cancer", "Transfusiones", "Autoinmunes", "Traumático"],
          default:
            break;
        }
      });
      patologicos.otros = this.state.sectionAilment.commentary[0];

      var quirurgicos = {}
      this.state.sectionAilment.ailments[1].quirurgicos.map((ailment, index) => {
        switch (index) {
          case 0:
            quirurgicos.quirurgico = { value: ailment.value, comentario: ailment.commentary, table: ailment.table };
            break;
          default:
            break;
        }
      });
      //quirurgicos.table = this.state.sectionAilment.ailments[1];
      console.log(this.state.sectionAilment);

      var farmacologicos = {}
      this.state.sectionAilment.ailments[2].farmacologicos.map((ailment, index) => {
        switch (index) {
          case 0:
            farmacologicos.farmacologico = { value: ailment.value, comentario: ailment.commentary, table: ailment.table };
            break;
          default:
            break;
        }
      });
      //farmacologicos.otros = this.state.sectionAilment.commentary[2];

      var urgencias = {}
      this.state.sectionAilment.ailments[3].urgencias.map((ailment, index) => {
        switch (index) {
          case 0:
            urgencias.urgencias = { value: ailment.value, comentario: ailment.commentary, table: ailment.table };
            break;
          default:
            break;
        }
      });
      //ginecoobstetricos.otros = this.state.sectionAilment.commentary[2];

      var hospitalizaciones = {};
      this.state.sectionAilment.ailments[4].hospitalizaciones.map((ailment, index) => {
        switch (index) {
          case 0:
            hospitalizaciones.hospitalizaciones = { value: ailment.value, comentario: ailment.commentary, table: ailment.table };
            break;
          default:
            break;
        }
      });
      //inm

      var planificacion = {};
      this.state.sectionAilment.ailments[5].planificacion.map((ailment, index) => {
        switch (index) {
          case 0:
            planificacion.vasectomia = { value: ailment.value, comentario: ailment.commentary };
            break;
          case 1:
            planificacion.planifica = { value: ailment.value, comentario: ailment.commentary };
            break;
          case 2:
            planificacion.pareja_sexual = { value: ailment.value, comentario: ailment.commentary };
            break;
          default:
            break;
        }
      });
      //inm


      planificacion.metodo = { value: this.state.sectionAilment.planification.method };

      planificacion.observacion = { value: this.state.sectionAilment.planification.observations };

      planificacion.otro_metodo = { value: this.state.sectionAilment.planification.ohter_method };


      var inmunizaciones = {};
      this.state.sectionAilment.ailments[6].inmunización.map((ailment, index) => {
        switch (index) {
          case 0:
            inmunizaciones.inmunizaciones = { value: ailment.value, comentario: ailment.commentary, table: ailment.table };
            break;
          default:
            break;
        }
      });
      //inmunizaciones.otros = this.state.sectionAilment.commentary[4];


      var familiares = {}
      this.state.sectionAilment.ailments[7].familiares.map((ailment, index) => {
        switch (index) {
          case 0:
            familiares.enf_coronaria = { value: ailment.value, comentario: ailment.commentary };
            break;
          case 1:
            familiares.diabetes = { value: ailment.value, comentario: ailment.commentary };
            break;
          case 2:
            familiares.cancer = { value: ailment.value, comentario: ailment.commentary };
            break;
          case 3:
            familiares.muerte_subita = { value: ailment.value, comentario: ailment.commentary };
            break;
          case 4:
            familiares.hipertension = { value: ailment.value, comentario: ailment.commentary };
            break;
          default:
            break;
        }
      });
      familiares.otros = this.state.sectionAilment.commentary[1];

      var formulas = this.state.MedicalOrders.formulas.map((formula) => {
        return {
          principio_activo: formula.activePrinciple,
          concentracion: formula.concentration,
          forma_farmaceutica: formula.pharmaceuticalForm,
          via_administracion: formula.route,
          dosis: formula.dose,
          frecuencia: formula.frequency,
          duracion: formula.duration,
          unidades_requeridas: formula.units
        }
      });

      var diagnostics = this.state.Diagnostic.addedDiagnostics.map((diagnostic, index) => {
        diagnostic.observacion = this.state.Diagnostic.observations[index]
        return diagnostic;
      });

      var dataHistory = {
        id_historia: this.props.data.id_historia,
        id_admision: this.props.data.id_admision,
        antecedentes: {
          patologicos: [
            patologicos
          ],
          quirurgicos: [
            quirurgicos
          ],
          farmacologicos: [
            farmacologicos
          ],
          urgencias: [
            urgencias
          ],
          hospitalizaciones: [
            hospitalizaciones
          ],
          planificacion: [
            planificacion
          ],
          inmunizaciones: [
            inmunizaciones
          ],
          habitos: [
            {
              fumador: this.state.sectionAilment.habits.smoke.value,
              paquetes_anio: this.state.sectionAilment.habits.packegesPerYear,
              cigarillos_dia: this.state.sectionAilment.habits.cigarretsPerDay,
              ano_inicio: this.state.sectionAilment.habits.yearStart,
              ano_fin: this.state.sectionAilment.habits.yearEnd,
              humo_lena: this.state.sectionAilment.habits.firewood.value,
              tiempo_anios: this.state.sectionAilment.habits.years,
              alcohol: this.state.sectionAilment.habits.alcohol.value,
              alcohol_ultimo_anio: this.state.sectionAilment.habits.alcoholLastYear.value,
              alcohol_frecuencia: this.state.sectionAilment.habits.frecuencyAlcohol.value,
              sustancia_psico: this.state.sectionAilment.habits.physicalActivity.value,
              sustancia_frecuencia: this.state.sectionAilment.habits.frecuency.value,
              cocaina: this.state.sectionAilment.habits.substaces.map((substance) => { return substance.value === "Cocaina" }).includes(true) ? "Si" : "No",
              bazuco: this.state.sectionAilment.habits.substaces.map((substance) => { return substance.label === "Bazuco" }).includes(true) ? "Si" : "No",
              extasis: this.state.sectionAilment.habits.substaces.map((substance) => { return substance.label === "Extasis" }).includes(true) ? "Si" : "No",
              heroina: this.state.sectionAilment.habits.substaces.map((substance) => { return substance.label === "Heroina" }).includes(true) ? "Si" : "No",
              lsd: this.state.sectionAilment.habits.substaces.map((substance) => { return substance.label === "LSD" }).includes(true) ? "Si" : "No",
              hongos: this.state.sectionAilment.habits.substaces.map((substance) => { return substance.label === "Hongos" }).includes(true) ? "Si" : "No",
              marihuana: this.state.sectionAilment.habits.substaces.map((substance) => { return substance.label === "Marihuana" }).includes(true) ? "Si" : "No",
              ghb: this.state.sectionAilment.habits.substaces.map((substance) => { return substance.label === "GHB" }).includes(true) ? "Si" : "No",
              sustancias_otras: this.state.sectionAilment.habits.substace,
              actividad_fisica: this.state.sectionAilment.habits.physicalActivity.value,
              actividad_frecuencia: this.state.sectionAilment.habits.frecuencyPhysicalActivity.value,
              actividades_cuales: this.state.sectionAilment.habits.activities
            }
          ],
          familiares: [
            familiares
          ]
        },
        anamnesis: {
          causa_ingreso: this.state.anamesis.cause,
          motivo_consulta: this.state.anamesis.reasonForConsultation,
          enfermedad_actual: this.state.anamesis.currentIllness,
          candidato_estudio: this.state.anamesis.candidate,
          acronimo_estudio: this.props.data.acronym,
          participa_estudio: this.state.anamesis.participate,
          id_estudio: this.props.data.id_estudio
        },
        fisico: {
          peso: this.state.PhysicalExam.weight,
          talla: this.state.PhysicalExam.size,
          masa_corporal: this.state.PhysicalExam.BMI,
          peri_abdominal: this.state.PhysicalExam.abdominalPerimeter,
          superficie_corporal: this.state.PhysicalExam.bodySurface,
          dominancia: this.state.PhysicalExam.dominance,
          frecuencia_cardiaca: this.state.PhysicalExam.heartRate,
          frecuencia_respiratoria: this.state.PhysicalExam.breathingFrequency,
          temperatura: this.state.PhysicalExam.temperature,
          presion_arterial: this.state.PhysicalExam.bloodPressure,
          aspecto_general: this.state.PhysicalExam.generalFeatures,
          cabeza_cara: this.state.PhysicalExam.headAndFace,
          otorrino: this.state.PhysicalExam.otorhino,
          ojos: this.state.PhysicalExam.eyes,
          cuello: this.state.PhysicalExam.neck,
          torax: this.state.PhysicalExam.chest,
          cardiovascular: this.state.PhysicalExam.cardioVascular,
          pulmonar: this.state.PhysicalExam.pulmonary,
          abdomen: this.state.PhysicalExam.abdomen,
          extremidades: this.state.PhysicalExam.limbs,
          neurologico: this.state.PhysicalExam.genitourinary,
          genitourinario: this.state.PhysicalExam.skin_appendages,
          piel_faneras: this.state.PhysicalExam.skin_appendages,
          genero: this.state.PhysicalExam.gender
        },
        diagnostico: {
          diagnostico: diagnostics,
        },
        procedimiento: {
          fecha: moment(new Date()).format("YYYY/MM/DD"),
          hora: moment(new Date()).format("hh:mm A"),
          eco: [
            {
              profesional: this.state.MedicalProcedures.ECO.professional,
              vid: this.state.MedicalProcedures.ECO.vid,
              pp: this.state.MedicalProcedures.ECO.pp,
              ps: this.state.MedicalProcedures.ECO.ps,
              vis: this.state.MedicalProcedures.ECO.vis,
              fe: this.state.MedicalProcedures.ECO.fe,
              rao: this.state.MedicalProcedures.ECO.rao,
              anillo_ao: this.state.MedicalProcedures.ECO.ao,
              vd: this.state.MedicalProcedures.ECO.vd,
              ai: this.state.MedicalProcedures.ECO.ai,
              e: this.state.MedicalProcedures.ECO.e,
              a: this.state.MedicalProcedures.ECO.a,
              tap_se: this.state.MedicalProcedures.ECO.tapse,
              ad: this.state.MedicalProcedures.ECO.ad,
              descripcion: this.state.MedicalProcedures.ECO.description,
              conclusiones: this.state.MedicalProcedures.ECO.conclusions,
              diagnostico: this.state.MedicalProcedures.ECO.addedMedicaments
            }
          ],
          estres: [
            {
              profesional: this.state.MedicalProcedures.Stress.professional,
              vid: this.state.MedicalProcedures.Stress.vid,
              pp: this.state.MedicalProcedures.Stress.pp,
              ps: this.state.MedicalProcedures.Stress.ps,
              vis: this.state.MedicalProcedures.Stress.vis,
              fe: this.state.MedicalProcedures.Stress.fe,
              rao: this.state.MedicalProcedures.Stress.rao,
              anillo_ao: this.state.MedicalProcedures.Stress.ao,
              vd: this.state.MedicalProcedures.Stress.vd,
              ai: this.state.MedicalProcedures.Stress.ai,
              e: this.state.MedicalProcedures.Stress.e,
              a: this.state.MedicalProcedures.Stress.a,
              tap_se: this.state.MedicalProcedures.Stress.tapse,
              ad: this.state.MedicalProcedures.Stress.ad,
              reposo: "",
              ejercicio: "",
              conclusiones: this.state.MedicalProcedures.Stress.conclusions,
              diagnostico: this.state.MedicalProcedures.Stress.addedMedicaments
            }
          ],
          prueba: [
            {
              profesional: this.state.MedicalProcedures.Test.professional,
              conclusiones: this.state.MedicalProcedures.Test.conclusions,
              conclusion: this.state.MedicalProcedures.Test.conclusion,
              diagnostico: this.state.MedicalProcedures.Test.addedMedicaments
            }
          ],
          ekg: [
            {
              profesional: this.state.MedicalProcedures.EKG.professional,
              ritmo: this.state.MedicalProcedures.EKG.ritmo,
              fc: this.state.MedicalProcedures.EKG.fc,
              onda_p: this.state.MedicalProcedures.EKG.ondaP,
              pr: this.state.MedicalProcedures.EKG.pr,
              qr_s: this.state.MedicalProcedures.EKG.qrs,
              eje_qrs: this.state.MedicalProcedures.EKG.ejeQRS,
              conclusion: this.state.MedicalProcedures.EKG.conclusions,
              diagnostico: this.state.MedicalProcedures.EKG.addedMedicaments
            }
          ],
          holter: [
            {
              profesional: this.state.MedicalProcedures.Holter.professional,
              conclusion: this.state.MedicalProcedures.Holter.conclusion,
              diagnostico: this.state.MedicalProcedures.Holter.addedMedicaments
            }
          ],
          mapa: [
            {
              profesional: this.state.MedicalProcedures.Map.professional,
              conclusion: this.state.MedicalProcedures.Map.conclusion,
              diagnostico: this.state.MedicalProcedures.Map.addedMedicaments
            }
          ]
        },
        sistemas: {
          sintomas_generales: this.state.SystemReview.ailments[0].commentary,
          respiratorio: this.state.SystemReview.ailments[1].commentary,
          cardiovascular: this.state.SystemReview.ailments[2].commentary,
          gastrointestinal: this.state.SystemReview.ailments[3].commentary,
          genitourinario: this.state.SystemReview.ailments[4].commentary,
          osteomuscular: this.state.SystemReview.ailments[5].commentary,
          dermatologico: this.state.SystemReview.ailments[6].commentary,
          endocrino: this.state.SystemReview.ailments[7].commentary,
          neurologico: this.state.SystemReview.ailments[8].commentary
        },
        ordenes: {
          tratamiento: formulas,
          ordenes: this.state.MedicalOrders,
          observaciones: this.state.MedicalOrders.observations,
          vigencia: this.state.MedicalOrders.time
        },
        plan: {
          analisis: this.state.AnalysisAndMedicalPlan.analysis,
          plan_medico: this.state.AnalysisAndMedicalPlan.plan,
          recomendaciones: this.state.AnalysisAndMedicalPlan.recommendations
        }
      }

      console.log(dataHistory);
      fetch(process.env.REACT_APP_PUBLIC_URL + 'evento/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(dataHistory)
      })
        .then(response => {
          return response.text();
        })
        .then(data => {
          console.log(data);
          alert(" Historia creada con exito ");
          this.setState({ stateClinicistory: "Cerrada" }, () => {
            history.push({
              pathname: process.env.PUBLIC_URL + '/assitencial/search-clinic-history',
              state: { date: this.props.data.fecha }
            });
          })
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  }

  render() {
    const { activeTab } = this.state;

    return (
      <Col>
        <Col md={12}>
          <h3 style={{ marginBottom: 30 }}>Historia Cliníca</h3>
          <Button
            style={{ marginBottom: 20 }}
            color="primary"
            size="sm"
            onClick={() => {
              history.push({
                pathname: process.env.PUBLIC_URL + '/assitencial/search-clinic-history',
                state: { date: this.props.data.fecha }
              });
            }}
          ><ArrowBackIcon />
          </Button>
        </Col>
        <Card>
          <CardBody>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            </div>
            <div className="tabs tabs--bordered-top">
              <div className="tabs__wrap">
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '1' })}
                      onClick={() => {
                        this.toggle('1');
                      }}
                    >
                      Datos Básicos
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '2' })}
                      onClick={() => {
                        this.toggle('2');
                      }}
                    >
                      Anamnesis
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '3' })}
                      onClick={() => {
                        this.toggle('3');
                      }}
                    >
                      Antecedentes
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '4' })}
                      onClick={() => {
                        this.toggle('4');
                      }}
                    >
                      Revisión por Sistema
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '5' })}
                      onClick={() => {
                        this.toggle('5');
                      }}
                    >
                      Examen Físico
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '6' })}
                      onClick={() => {
                        this.toggle('6');
                      }}
                    >
                      Diagnostico
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '7' })}
                      onClick={() => {
                        this.toggle('7');
                      }}
                    >
                      Análisis y Plan Médico
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '8' })}
                      onClick={() => {
                        this.toggle('8');
                      }}
                    >
                      Ordenes Médicas
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '9' })}
                      onClick={() => {
                        this.toggle('9');
                      }}
                    >
                      Resultados Exámenes
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '10' })}
                      onClick={() => {
                        this.toggle('10');
                      }}
                    >
                      Procedimientos
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '11' })}
                      onClick={() => {
                        this.toggle('11');
                      }}
                    >
                      Documentos Fuente
                    </NavLink>
                  </NavItem>
                  {this.state.anamesis.participate ?
                    <Fragment>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === '12' })}
                          onClick={() => {
                            this.toggle('12');
                          }}
                        >
                          Criterios de Incluisión y exclusión
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === '13' })}
                          onClick={() => {
                            this.toggle('13');
                          }}
                        >
                          Consentimiento Informado
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === '14' })}
                          onClick={() => {
                            this.toggle('14');
                          }}
                        >
                          Eventos Adversos
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === '15' })}
                          onClick={() => {
                            this.toggle('15');
                          }}
                        >
                          Desviaciones Protocolo
                        </NavLink>
                      </NavItem>
                    </Fragment>
                    : null}
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1">
                    <BasicDataPatient num_documento={this.props.data !== undefined ? this.props.data.num_documento : this.props.location.state.dataPatient.num_documento} /> {/*this.props.data.num_documento*/}
                  </TabPane>
                  <TabPane tabId="2">
                    <Ananmesis
                      id_historia={this.props.data.id_historia}
                      id_admision={this.props.data.id_admision}
                      acronym={this.props.data.acronym}
                      loadAnamesis={this.loadAnamesis}
                      anamesis={this.state.anamesis}
                      handlerSelectCauseOfAdmission={this.handlerSelectCauseOfAdmission}
                      handlerReasonForConsultation={this.handlerReasonForConsultation}
                      handlerCurrentIllness={this.handlerCurrentIllness}
                      handlerCandidate={this.handlerCandidate}
                      handlerParticipate={this.handlerParticipate}
                    />
                  </TabPane>
                  <TabPane tabId="3">
                    <DefaultTabsBorderedTopBackground
                      sections={sections}
                      ailments={ailments}
                      sectionAilment={this.state.sectionAilment}
                      loadBackgroud={this.loadBackgroud}
                      searchMedicaments={this.searchMedicaments}
                      handlerAilment={this.handlerAilment}
                      handlerComments={this.handlerComments}
                      handlerAlimentDate={this.handlerAlimentDate}
                      handlerAlimentTable={this.handlerAlimentTable}
                      handlerCommentary={this.handlerCommentary}
                      handlerPlanificacion={this.handlerPlanificacion}
                      habits={this.state.sectionAilment.habits}
                      handlerHabits={this.handlerHabits}
                      searchDiagnostic={this.searchCIE}
                    />
                  </TabPane>
                  <TabPane tabId="4">
                    <SystemReview
                      ailments={this.state.SystemReview.ailments}
                      loadSystemReview={this.loadSystemReview}
                      handlerCommentsSystemReview={this.handlerCommentsSystemReview}
                    />
                  </TabPane>
                  <TabPane tabId="5">
                    <PhysicalExam
                      PhysicalExam={this.state.PhysicalExam}
                      loadPhysicalExam={this.loadPhysicalExam}
                      handlerPhysicalExam={this.handlerPhysicalExam}
                      handlerWeight={this.handlerWeight}
                      handlerSize={this.handlerSize}
                      calculateSurfaceBody={this.calculateSurfaceBody}
                      birthday={this.props.data.birthday}
                      gender={this.props.data.sexo}
                    />
                  </TabPane>
                  <TabPane tabId="6">
                    <Diagnostic
                      id_historia={this.props.data.id_historia}
                      id_admision={this.props.data.id_admision}
                      Diagnostic={this.state.Diagnostic}
                      loadDiagnostic={this.loadDiagnostic}
                      handlerCUPS={this.handlerCUPS}
                      handlerDiagnosticName={this.handlerDiagnosticName}
                      searchDiagnostic={this.searchCIE}
                      selectDiagnostic={this.selectDiagnostic}
                      addDiagnostic={this.addDiagnostic}
                      addObservation={this.handlerAddObservationDiagnostic}
                      removeDiagnostic={this.removeDiagnostic}
                    />
                  </TabPane>
                  <TabPane tabId="7">
                    <AnalysisAndMedicalPlan
                      AnalysisAndMedicalPlan={this.state.AnalysisAndMedicalPlan}
                      loadAnalysisAndMedicalPlan={this.loadAnalysisAndMedicalPlan}
                      handlerAnalysis={this.handlerAnalysis}
                      handlerPlan={this.handlerPlan}
                      handlerRecommendations={this.handlerRecommendations}
                    />
                  </TabPane>
                  <TabPane tabId="8">
                    <MedicalOrders
                      id_historia={this.props.data.id_historia}
                      id_admision={this.props.data.id_admision}
                      MedicalOrders={this.state.MedicalOrders}
                      loadMedicalOrders={this.loadMedicalOrders}
                      handlerCUPS={this.handlerMedicalOrdersCUPS}
                      handlerDiagnosticName={this.handlerMedicalOrdersDiagnosticName}
                      searchDiagnostic={this.searchDiagnostic}
                      searchMedicaments={this.searchMedicaments}
                      selectDiagnostic={this.selectMedicalOrdersDiagnostic}
                      searchMedicalOrders={this.searchMedicalOrders}
                      addDiagnostic={this.addMedicalOrderDiagnostic}
                      removeDiagnostic={this.removeMedicalOrderDiagnostic}
                      addObservation={this.handlerAddObservation}
                      handlerMedicalOrderTime={this.handlerMedicalOrderTime}
                      handlerFormulasNew={this.handlerFormulasNew}
                      removeFormula={this.removeFormula}
                    />
                  </TabPane>
                  <TabPane tabId="9">
                    <ExamResult
                      id_historia={this.props.data.id_historia}
                      id_admision={this.props.data.id_admision} />
                  </TabPane>
                  <TabPane tabId="10">
                    <MedicalProcedures
                      examResults={this.state.examResults}
                      MedicalProcedures={this.state.MedicalProcedures}
                      loadMedicalProcedures={this.loadMedicalProcedures}
                      handlerMedicalProcedures={this.handlerMedicalProcedures}
                      handlerMedications={this.handlerMedications}
                      selectMedicament={this.selectMedicament}
                      searchMedications={this.searchMedications}
                      addMedicament={this.addMedicament}
                      removeMedicament={this.removeMedicament}
                      createHistory={this.createHistory}
                      id_historia={this.props.data.id_historia}
                      id_admision={this.props.data.id_admision}
                      num_documento={this.props.data.num_documento}
                    />
                  </TabPane>
                  <TabPane tabId="11">
                    <SourceDocuments
                      id_historia={this.props.data.id_historia}
                      id_admision={this.props.data.id_admision} />
                  </TabPane>
                  {this.state.anamesis.participate ?
                    <Fragment>
                      <TabPane tabId="12">
                        <Criteria
                          id_historia={this.props.data.id_historia}
                          id_admision={this.props.data.id_admision}
                          id_paciente={this.props.data.id_paciente}
                          id_visita={this.props.data.id_visita}
                          id_estudio={this.props.data.id_estudio} />
                      </TabPane>
                      <TabPane tabId="13">
                        <Consent
                          id_historia={this.props.data.id_historia}
                          id_admision={this.props.data.id_admision}
                          id_estudio={this.props.data.id_estudio} />
                      </TabPane>
                      <TabPane tabId="14">
                        <EventAdverse
                          searchDiagnostic={this.searchCIE}
                          id_historia={this.props.data.id_historia}
                          id_admision={this.props.data.id_admision} />
                      </TabPane>
                      <TabPane tabId="15">
                        <ProtocolDeviations
                          id_historia={this.props.data.id_historia}
                          id_admision={this.props.data.id_admision} />
                      </TabPane>
                    </Fragment>
                    : null}
                </TabContent>

              </div>
            </div>
            <div>

              {this.state.stateClinicistory === "Cerrada" || (this.state.profile !== "9" && this.state.profile !== "10") ? null :
                <Button
                  style={{ marginTop: 50 }}
                  onClick={() => {
                    this.createHistory()
                  }}
                >
                  Guardar
                </Button>}
            </div>
            <Modal
              open={this.state.openErrors}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              style={{ zIndex: 1000 }}
              onClose={() => {
                this.setState({ openErrors: false, btnActive: true })
              }}
            >
              <div style={{
                position: 'absolute',
                backgroundColor: '#ffffff',
                width: 400,
                top: '50%',
                left: '50%',
                transform: 'translate(-50%,-50%)',
                display: 'flex',
                margin: 10,
                padding: 20,
                flexDirection: 'column'
              }}
              >
                <div>{this.state.errors.anamesis !== undefined ?
                  <>
                    <div>
                      <h5>Anamesis</h5>
                      <div style={{ marginLeft: 20 }}>
                        {this.state.errors.anamesis.hasOwnProperty("cause") ? <p><span role="img" aria-label="warning">⚠</span> {this.state.errors.anamesis.cause}</p> : null}
                        {this.state.errors.anamesis.hasOwnProperty("reasonForConsultation") ? <p><span role="img" aria-label="warning">⚠</span> {this.state.errors.anamesis.reasonForConsultation}</p> : null}
                        {this.state.errors.anamesis.hasOwnProperty("currentIllness") ? <p><span role="img" aria-label="warning">⚠</span> {this.state.errors.anamesis.currentIllness}</p> : null}
                      </div>
                    </div>
                  </>
                  : null}
                </div>
                <div style={{ marginTop: 10 }} >{this.state.errors.analysisAndMedicalPlan !== undefined ?
                  <>
                    <div>
                      <h5>Analisis y plan medico</h5>
                      <div style={{ marginLeft: 20 }}>
                        {this.state.errors.analysisAndMedicalPlan.hasOwnProperty("analysis") ? <p><span role="img" aria-label="warning">⚠</span> {this.state.errors.analysisAndMedicalPlan.analysis}</p> : null}
                        {this.state.errors.analysisAndMedicalPlan.hasOwnProperty("plan") ? <p><span role="img" aria-label="warning">⚠</span> {this.state.errors.analysisAndMedicalPlan.plan}</p> : null}
                        {this.state.errors.analysisAndMedicalPlan.hasOwnProperty("recommendations") ? <p><span role="img" aria-label="warning">⚠</span>{this.state.errors.analysisAndMedicalPlan.recommendations}</p> : null}
                      </div>
                    </div>
                  </>
                  : null}
                </div>
              </div>
            </Modal>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

//export default withTranslation('common')(DefaultTabsBorderedTop);
export default reduxForm({
  form: 'clinic_history_form', // a unique identifier for this form
})(withTranslation('common')(DefaultTabsBorderedTop));